import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-contribute',
  templateUrl: './contribute.component.html',
  styleUrls: ['./contribute.component.scss']
})
export class ContributePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
